import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import HeroImage from "../components/global/heroImage"
import Info from "../components/home/info"
import SuitableFor from "../components/home/suitableFor"
import Facilities from "../components/home/facilities"

const IndexPage = ({ data }) => (
  <Layout>
    <SEO title="Home" />
    <HeroImage
      img={data.homePage.featured_media.localFile.childImageSharp.fluid}
      styleClass="default-background"
      title={data.site.siteMetadata.description}
    />
    <Info content={data.homePage.acf.habitat_hills_info.text} />
    <SuitableFor data={data.suitableFor.edges} />
    <Facilities data={data.facilities.edges} />
  </Layout>
)

export default IndexPage

export const query = graphql`
  query {
    site {
      siteMetadata {
        description
      }
    }
    homePage: wordpressPage(slug: { eq: "home-page" }) {
      acf {
        habitat_hills_info
      }
      featured_media {
        localFile {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    suitableFor: allWordpressWpSuitableFor {
      edges {
        node {
          id
          title
          featured_media {
            localFile {
              childImageSharp {
                fixed(width: 150, height: 150) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
        }
      }
    }
    facilities: allWordpressWpFacilities {
      edges {
        node {
          id
          title
          featured_media {
            localFile {
              childImageSharp {
                fixed(height: 600, width: 600) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
        }
      }
    }
  }
`
